/*  eslint-disable */

import React from "react"

import RootApolloProvider from "./src/apolloClient/ApolloProvider"

export const wrapRootElement = ({ element }) => {
  return <RootApolloProvider>{element}</RootApolloProvider>
}
